import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["sectionTitle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { get, isNumber, isString } from 'lodash';
import { getTruelyValueMap } from '../../../constants/common';
import { BI_COW_COVER, BUSINESS_INTERUPTION, CMR_COVER, COMPUTER_BREAKDOWN_COVER, DIRECTORS_OFFICERS_COVER, DRIVERS_NEGLIGENCE, EMPLOYERS_LIABILITY, EMPLOYMENT_PRACTICES_COVER, EMPLOYMENT_PRACTICES_EXCESS_LEVEL, EXCESS_LEVEL, FIDELITY_CRIME, GOODS_IN_TRANSIT, MONEY_ASSAULT_COVER, PORTABLE_EQUIPMENT, PORTABLE_EQUIPMENT_COVER, PROFESSIONAL_INDEMNITY, PROPERTY_COVER_TYPE_LIST, PUBLIC_LIABILITY } from '../../../constants/coverage';
import { PROVIDER_SOURCE, incomeSplitCountriesMap } from '../../../constants/quote';
import { judgeCanChooseAccountancyActivities, judgeCanChooseEstateAgentActivities, judgeQuoteIsCombineR2RScheme } from '../../../flagJudgement/quote';
import { GIT_DECLARATION_ID, GREAT_AMERICAN_DECLARATION_P1, GREAT_AMERICAN_FAST_PROCESS_DECLARATION_P1, RECRUITMENT_DECLARATION, getAllQuoteQuestionInfoMap, getCoverInfoMapWithExtraConfig, getGreateAmericanCoverMap, getGreateAmericanStateList } from '../../../localeConstants';
import { getJoveCountryCurrencySymbolNative } from '../../currency';
import { getLocalTranslation } from '../../i18nKit';
import { removeAccountancyDeclarations } from '../../questions';
import { formatCommonDateStrKeepDatePart } from '../../time';
import { getQuoteRelatedUserAndPromotionInformationList } from '../broker';
import { getAverageRadiusOperationDropdownOptions, getBusinessActivityDropdownOptions, getBusinessTypeDropdownOptions, getCountryDropdownOptions, getCoverDropdownOptions, getCoverOptionList, getDeclarationDropdownOptions, getInsuranceBundleDropdownOptions, getRecruitmentBusinessTypeDropdownOptions, getStateDropdownOptions, getTypeOfRemovalJobDropdownOptions, getYearsInBusinessDropdownOptions, getYesNoDropdownOptions } from '../dataSources';
import { QuoteFormSectionTitleInfoEnum, getQuoteFormDisplayTitleInfo } from '../formDisplayTitle';
import { getAverageRadiusOperationDisplayText, getBusinessActivityDisplayText, getBusinessTypeDisplayText, getCoverTypeDisplayText, getInsuranceBundleDisplayText, getPolicyTypeDisplayText, getRecruitmentBusinessTypeDisplayText, getTypeOfRemovalJobDisplayText, getYearsInBusinessDisplayText } from '../text'; // Resolve translations at call time so the generated form reflects the language active when the
// rows are built: the application form temporarily switches i18n to the quote's businessCountry
// language before generating the PDF / Word file, then restores the user's own language.

var $t = function $t(key) {
  return getLocalTranslation().$t(key);
};

export var ApplicationFormSectionTitleEnum;

(function (ApplicationFormSectionTitleEnum) {
  ApplicationFormSectionTitleEnum["broker"] = "broker";
  ApplicationFormSectionTitleEnum["client"] = "client";
  ApplicationFormSectionTitleEnum["business"] = "business";
  ApplicationFormSectionTitleEnum["vehicles"] = "vehicles";
  ApplicationFormSectionTitleEnum["covers"] = "covers";
  ApplicationFormSectionTitleEnum["claims"] = "claims";
  ApplicationFormSectionTitleEnum["declarations"] = "declarations";
  ApplicationFormSectionTitleEnum["additionalInformation"] = "additionalInformation";
})(ApplicationFormSectionTitleEnum || (ApplicationFormSectionTitleEnum = {}));

var getApplicationFormSectionTitleMap = function getApplicationFormSectionTitleMap() {
  var _ref;

  return _ref = {}, _defineProperty(_ref, ApplicationFormSectionTitleEnum.broker, $t('kit:application_form.broker_details')), _defineProperty(_ref, ApplicationFormSectionTitleEnum.client, $t('kit:application_form.client_details')), _defineProperty(_ref, ApplicationFormSectionTitleEnum.business, $t('kit:application_form.business_details')), _defineProperty(_ref, ApplicationFormSectionTitleEnum.vehicles, $t('kit:quotes.vehicles')), _defineProperty(_ref, ApplicationFormSectionTitleEnum.covers, $t('kit:application_form.covers')), _defineProperty(_ref, ApplicationFormSectionTitleEnum.claims, $t('kitQuestion:claims')), _defineProperty(_ref, ApplicationFormSectionTitleEnum.declarations, $t('kit:application_form.declarations')), _defineProperty(_ref, ApplicationFormSectionTitleEnum.additionalInformation, $t('text:additional_information')), _ref;
};

var hasValue = function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
};

var displayRawValue = function displayRawValue(value) {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  if (typeof value === 'boolean') {
    var _getTruelyValueMap = getTruelyValueMap(),
        yes = _getTruelyValueMap.yes,
        no = _getTruelyValueMap.no;

    return value ? yes.label : no.label;
  }

  if (isNumber(value) || isString(value)) {
    return String(value);
  }

  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (_unused) {
      return '';
    }
  }

  return String(value);
};

var displayDateValue = function displayDateValue(value) {
  if (!value) {
    return '';
  }

  if (typeof value === 'string' || value instanceof Date) {
    return formatCommonDateStrKeepDatePart(value);
  }

  return displayRawValue(value);
};

var getCurrencySymbol = function getCurrencySymbol(quoteDetails) {
  return getJoveCountryCurrencySymbolNative({
    country: (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.businessCountry) || (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.country),
    countries: quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.countries
  });
};
/**
 * Resolve an application form row title from the shared quote form title info.
 * Application form rows are field-style labels, so the short `itemLabel` variant is used.
 */


var getApplicationFormRowTitle = function getApplicationFormRowTitle(type) {
  var _getQuoteFormDisplayT;

  return ((_getQuoteFormDisplayT = getQuoteFormDisplayTitleInfo(type)) === null || _getQuoteFormDisplayT === void 0 ? void 0 : _getQuoteFormDisplayT.quoteTitle) || '';
};

var getApplicationFormRowBriefTitle = function getApplicationFormRowBriefTitle(type) {
  var _getQuoteFormDisplayT2;

  return ((_getQuoteFormDisplayT2 = getQuoteFormDisplayTitleInfo(type)) === null || _getQuoteFormDisplayT2 === void 0 ? void 0 : _getQuoteFormDisplayT2.itemLabel) || '';
};
/**
 * Client: contact information
 */


var buildContactInformationData = function buildContactInformationData(list, quoteDetails) {
  var _countries$find;

  var _ref2 = quoteDetails || {},
      firstName = _ref2.firstName,
      lastName = _ref2.lastName,
      email = _ref2.email,
      phone = _ref2.phone,
      country = _ref2.country,
      countries = _ref2.countries;

  list.push.apply(list, [{
    title: $t('kit:quotes.first_name'),
    content: firstName,
    required: true,
    fieldKey: 'firstName',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:quotes.last_name'),
    content: lastName,
    required: true,
    fieldKey: 'lastName',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:quotes.email'),
    content: email,
    required: true,
    fieldKey: 'email',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:quotes.phone_number'),
    content: phone,
    required: true,
    fieldKey: 'phone',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, _objectSpread(_objectSpread({
    title: $t('kit:quotes.country'),
    content: countries === null || countries === void 0 ? void 0 : (_countries$find = countries.find(function (item) {
      return item.value === country;
    })) === null || _countries$find === void 0 ? void 0 : _countries$find.label,
    required: true,
    fieldKey: 'country',
    inputType: 'dropdown'
  }, getCountryDropdownOptions(quoteDetails)), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.client
  })]);
};
/**
 * Client: business type
 */


var buildBusinessTypeData = function buildBusinessTypeData(list, quoteDetails) {
  list.push(_objectSpread(_objectSpread({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.businessType),
    content: getBusinessTypeDisplayText(quoteDetails),
    required: true,
    fieldKey: 'businessType',
    inputType: 'dropdown'
  }, getBusinessTypeDropdownOptions(quoteDetails)), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }));
};
/**
 * Client: personal details (birth date)
 */


var buildPersonalData = function buildPersonalData(list, quoteDetails) {
  var _ref3 = quoteDetails || {},
      birthDate = _ref3.birthDate;

  list.push({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.dateOfBirth),
    content: displayDateValue(birthDate),
    fieldKey: 'birthDate',
    inputType: 'date',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  });
};
/**
 * Client: company name and address
 */


var buildCompanyAndAddressData = function buildCompanyAndAddressData(list, quoteDetails) {
  var _ref4 = quoteDetails || {},
      companyName = _ref4.companyName,
      businessType = _ref4.businessType,
      businessAddress = _ref4.businessAddress,
      detailedAddress = _ref4.detailedAddress,
      businessCity = _ref4.businessCity,
      businessPostcode = _ref4.businessPostcode,
      companyIncorporationDate = _ref4.companyIncorporationDate,
      registrationNumber = _ref4.registrationNumber,
      taxNumber = _ref4.taxNumber;

  list.push.apply(list, [{
    title: $t('kit:quotes.company_name'),
    content: companyName,
    required: true,
    fieldKey: 'companyName',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:quotes.street_address'),
    content: businessAddress,
    required: true,
    fieldKey: 'businessAddress',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:application_form.apt_suite_other'),
    content: detailedAddress,
    fieldKey: 'detailedAddress',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:application_form.town_city'),
    content: businessCity,
    required: true,
    fieldKey: 'businessCity',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:quotes.postcode'),
    content: businessPostcode,
    required: true,
    fieldKey: 'businessPostcode',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:application_form.company_incorporation_date'),
    content: displayDateValue(companyIncorporationDate),
    fieldKey: 'companyIncorporationDate',
    inputType: 'date',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('page:brokerLandingPageFooter.company_registration_number'),
    content: registrationNumber,
    fieldKey: 'registrationNumber',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:application_form.tax_number'),
    content: taxNumber,
    fieldKey: 'taxNumber',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }]);
};
/**
 * Client: great american company name and address
 */


var buildGreatAmericanCompanyAndAddressData = function buildGreatAmericanCompanyAndAddressData(list, quoteDetails) {
  var _getGreateAmericanSta, _getGreateAmericanSta2;

  var _ref5 = quoteDetails || {},
      companyName = _ref5.companyName,
      streetNumber = _ref5.streetNumber,
      businessAddress = _ref5.businessAddress,
      businessCity = _ref5.businessCity,
      businessCounty = _ref5.businessCounty,
      businessState = _ref5.businessState,
      businessPostcode = _ref5.businessPostcode,
      detailedAddress = _ref5.detailedAddress;

  list.push.apply(list, [{
    title: $t('kit:quotes.company_name'),
    content: companyName,
    required: true,
    fieldKey: 'companyName',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:application_form.building_number'),
    content: streetNumber,
    fieldKey: 'streetNumber',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:quotes.street_address'),
    content: businessAddress,
    required: true,
    fieldKey: 'businessAddress',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:application_form.town_city'),
    content: businessCity,
    required: true,
    fieldKey: 'businessCity',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:application_form.county'),
    content: businessCounty,
    fieldKey: 'businessCounty',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, _objectSpread(_objectSpread({
    title: $t('kit:application_form.state'),
    content: ((_getGreateAmericanSta = getGreateAmericanStateList()) === null || _getGreateAmericanSta === void 0 ? void 0 : (_getGreateAmericanSta2 = _getGreateAmericanSta.find(function (item) {
      return item.value === businessState;
    })) === null || _getGreateAmericanSta2 === void 0 ? void 0 : _getGreateAmericanSta2.label) || businessState,
    fieldKey: 'businessState',
    inputType: 'dropdown'
  }, getStateDropdownOptions()), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }), {
    title: $t('kit:quotes.postcode'),
    content: businessPostcode,
    required: true,
    fieldKey: 'businessPostcode',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }, {
    title: $t('kit:application_form.apt_suite_other'),
    content: detailedAddress,
    fieldKey: 'detailedAddress',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  }]);
};
/**
 * Client: policy start date
 */


var buildPolicyStartDateData = function buildPolicyStartDateData(list, quoteDetails) {
  var _ref6 = quoteDetails || {},
      projectPeriodStart = _ref6.projectPeriodStart;

  list.push({
    title: $t('kit:quotes.policy_start_date'),
    content: displayDateValue(projectPeriodStart),
    required: true,
    fieldKey: 'projectPeriodStart',
    inputType: 'date',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  });
};
/**
 * Client: type of policy
 */


var buildTypeOfPolicyData = function buildTypeOfPolicyData(list, quoteDetails) {
  list.push({
    title: $t('kit:application_form.type_of_policy'),
    content: getPolicyTypeDisplayText(quoteDetails),
    required: true,
    fieldKey: 'policyType',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  });
};
/**
 * Client: retroactive cover date
 */


var buildRetroactiveDateData = function buildRetroactiveDateData(list, quoteDetails) {
  var _ref7 = quoteDetails || {},
      retroactiveDate = _ref7.retroactiveDate;

  list.push({
    title: $t('kit:quotes.retroactive_date'),
    content: displayDateValue(retroactiveDate),
    fieldKey: 'retroactiveDate',
    sectionTitle: ApplicationFormSectionTitleEnum.client
  });
};
/**
 * Business: business activity
 */


var buildBusinessActivityData = function buildBusinessActivityData(list, quoteDetails) {
  list.push(_objectSpread(_objectSpread({
    title: getApplicationFormRowBriefTitle(QuoteFormSectionTitleInfoEnum.businessActivity),
    content: getBusinessActivityDisplayText(quoteDetails),
    required: true,
    fieldKey: 'businessActivity',
    inputType: 'dropdown'
  }, getBusinessActivityDropdownOptions(quoteDetails)), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.business
  }));
};
/**
 * Business: insurance bundle
 */


var buildInsuranceBundleData = function buildInsuranceBundleData(list, quoteDetails) {
  list.push(_objectSpread(_objectSpread({
    title: getApplicationFormRowBriefTitle(QuoteFormSectionTitleInfoEnum.insuranceBundle),
    content: getInsuranceBundleDisplayText(quoteDetails),
    required: true,
    fieldKey: 'insuranceBundle',
    inputType: 'dropdown'
  }, getInsuranceBundleDropdownOptions(quoteDetails)), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.business
  }));
};
/**
 * Business: number of employees
 */


var buildNumberOfEmployeesData = function buildNumberOfEmployeesData(list, quoteDetails) {
  var employees = get(quoteDetails, 'employees', get(quoteDetails, 'elSize.totalEmployees'));
  list.push({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.employees),
    content: displayRawValue(employees),
    required: true,
    fieldKey: 'employees',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: composition of employees (clerical / manual)
 */


var buildCompositionEmployeesData = function buildCompositionEmployeesData(list, quoteDetails) {
  var _ref8 = quoteDetails || {},
      elSize = _ref8.elSize;

  var _ref9 = elSize || {},
      clericalEmployees = _ref9.clericalEmployees,
      manualEmployees = _ref9.manualEmployees;

  list.push.apply(list, [{
    title: $t('kit:quotes.clerical_employees'),
    content: displayRawValue(clericalEmployees),
    fieldKey: 'elSize.clericalEmployees',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  }, {
    title: $t('kit:quotes.manual_employees'),
    content: displayRawValue(manualEmployees),
    fieldKey: 'elSize.manualEmployees',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  }]);
};
/**
 * Business: estimated turnover
 */


var buildEstimatedTurnoverData = function buildEstimatedTurnoverData(list, quoteDetails) {
  var _ref10 = quoteDetails || {},
      turnoverRaw = _ref10.turnoverRaw;

  list.push({
    title: getApplicationFormRowBriefTitle(QuoteFormSectionTitleInfoEnum.estimatedTurnover),
    content: "".concat(getCurrencySymbol(quoteDetails)).concat(turnoverRaw),
    required: true,
    fieldKey: 'turnoverRaw',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: income split
 */


var buildIncomeSplitData = function buildIncomeSplitData(list, quoteDetails) {
  var incomeOrigin = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.incomeOrigin) || {};
  var incomeSplitMap = incomeSplitCountriesMap();
  var labels = [];
  var values = [];
  Object.keys(incomeSplitMap).filter(function (key) {
    return !['US-CA'].includes(key);
  }).forEach(function (key) {
    var _incomeSplitMap$key;

    var value = incomeOrigin[key] || 0;
    var desc = (incomeSplitMap === null || incomeSplitMap === void 0 ? void 0 : (_incomeSplitMap$key = incomeSplitMap[key]) === null || _incomeSplitMap$key === void 0 ? void 0 : _incomeSplitMap$key.label) || '';

    if (desc) {
      var _incomeSplitMap$key2, _incomeSplitMap$key3;

      desc += !!(incomeSplitMap !== null && incomeSplitMap !== void 0 && (_incomeSplitMap$key2 = incomeSplitMap[key]) !== null && _incomeSplitMap$key2 !== void 0 && _incomeSplitMap$key2.desc) ? " (".concat(incomeSplitMap === null || incomeSplitMap === void 0 ? void 0 : (_incomeSplitMap$key3 = incomeSplitMap[key]) === null || _incomeSplitMap$key3 === void 0 ? void 0 : _incomeSplitMap$key3.desc, ")") : '';
    }

    labels.push(desc || key);
    values.push("".concat(value, "%"));
  });
  list.push({
    title: "".concat($t('kit:application_form.income_split'), "\n").concat(labels.join('\n')),
    content: values.join(', '),
    fieldKey: 'incomeOrigin',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: recruitment business type
 */


var buildRecruitmentBusinessTypeData = function buildRecruitmentBusinessTypeData(list, quoteDetails) {
  list.push(_objectSpread(_objectSpread({
    title: getApplicationFormRowBriefTitle(QuoteFormSectionTitleInfoEnum.recruitmentBusinessType),
    content: getRecruitmentBusinessTypeDisplayText(quoteDetails),
    required: true,
    fieldKey: 'recruitmentBusinessType',
    inputType: 'dropdown'
  }, getRecruitmentBusinessTypeDropdownOptions()), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.business
  }));
};
/**
 * Business: recruitment / payroll estimated split
 */


var buildRecruitmentEstimatedSplitData = function buildRecruitmentEstimatedSplitData(list, quoteDetails) {
  var _ref11 = quoteDetails || {},
      recruitmentSplitPercent = _ref11.recruitmentSplitPercent,
      payrollSplitPercent = _ref11.payrollSplitPercent;

  list.push({
    title: $t('kit:application_form.recruitment_split_percentage'),
    content: "".concat(recruitmentSplitPercent, "%"),
    fieldKey: 'recruitmentSplitPercent',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
  list.push({
    title: $t('kit:application_form.payroll_split_percentage'),
    content: "".concat(payrollSplitPercent, "%"),
    fieldKey: 'payrollSplitPercent',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: payroll for placed candidates
 */


var buildPayrollForPlacedCandidatesData = function buildPayrollForPlacedCandidatesData(list, quoteDetails) {
  var _ref12 = quoteDetails || {},
      payrollForPlacedCandidate = _ref12.payrollForPlacedCandidate;

  list.push({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.payrollForPlacedCandidates),
    content: "".concat(getCurrencySymbol(quoteDetails)).concat(payrollForPlacedCandidate || 0),
    fieldKey: 'payrollForPlacedCandidate',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: placed candidate split (permanent / temporary)
 */


var buildPlacedCandidateSplitData = function buildPlacedCandidateSplitData(list, quoteDetails) {
  var _ref13 = quoteDetails || {},
      permanentSplitPercentForPlacedCandidate = _ref13.permanentSplitPercentForPlacedCandidate,
      temporarySplitPercentForPlacedCandidate = _ref13.temporarySplitPercentForPlacedCandidate;

  list.push({
    title: $t('kit:application_form.permanent_split_for_placed_candidates'),
    content: "".concat(permanentSplitPercentForPlacedCandidate || 0, "%"),
    fieldKey: 'permanentSplitPercentForPlacedCandidate',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
  list.push({
    title: $t('kit:application_form.temporary_split_for_placed_candidates'),
    content: "".concat(temporarySplitPercentForPlacedCandidate || 0, "%"),
    fieldKey: 'temporarySplitPercentForPlacedCandidate',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: placement industries percentage
 */


var buildPlacementIndustriesPercentageData = function buildPlacementIndustriesPercentageData(list, quoteDetails) {
  var placementList = Array.isArray(quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.placementTypeAndSplitList) ? quoteDetails.placementTypeAndSplitList : [];
  placementList.forEach(function (item) {
    var _item$percent;

    list.push({
      title: "".concat($t('kit:application_form.placement_industry'), " - ").concat((item === null || item === void 0 ? void 0 : item.label) || (item === null || item === void 0 ? void 0 : item.value)),
      content: "".concat((_item$percent = item === null || item === void 0 ? void 0 : item.percent) !== null && _item$percent !== void 0 ? _item$percent : 0, "%"),
      fieldKey: "placementTypeAndSplitList.".concat((item === null || item === void 0 ? void 0 : item.value) || (item === null || item === void 0 ? void 0 : item.label)),
      sectionTitle: ApplicationFormSectionTitleEnum.business
    });
  });
};
/**
 * Business: employer reference number
 */


var buildEmployerReferenceNumberData = function buildEmployerReferenceNumberData(list, quoteDetails) {
  var _ref14 = quoteDetails || {},
      ern = _ref14.ern,
      ernExempt = _ref14.ernExempt;

  list.push({
    title: $t('kit:quotes.employer_reference_number'),
    content: ernExempt ? $t('kit:quotes.ern_exempt') : displayRawValue(ern),
    fieldKey: 'ern',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: dot number
 */


var buildDotNumberData = function buildDotNumberData(list, quoteDetails) {
  var _ref15 = quoteDetails || {},
      haveDotNumber = _ref15.haveDotNumber,
      dotNumber = _ref15.dotNumber;

  list.push({
    title: $t('kit:application_form.dot_number'),
    content: haveDotNumber ? displayRawValue(dotNumber) : $t('kit:application_form.i_dont_have_a_dot_number'),
    required: true,
    fieldKey: 'dotNumber',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: type of removal job
 */


var buildTypeOfRemovalJobData = function buildTypeOfRemovalJobData(list, quoteDetails) {
  list.push(_objectSpread(_objectSpread({
    title: $t('kit:application_form.type_of_removal_job'),
    content: getTypeOfRemovalJobDisplayText(quoteDetails),
    required: true,
    fieldKey: 'typeOfOperation',
    inputType: 'dropdown'
  }, getTypeOfRemovalJobDropdownOptions(quoteDetails)), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.business
  }));
};
/**
 * Business: type of commodities
 */


var buildTypeOfCommoditiesData = function buildTypeOfCommoditiesData(list, quoteDetails) {
  var commodityList = Array.isArray(quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.commodityList) ? quoteDetails.commodityList : [];
  commodityList.forEach(function (item, index) {
    var _ref16, _item$count;

    list.push({
      title: "".concat($t('kit:application_form.commodity'), " ").concat(index + 1, " - ").concat((item === null || item === void 0 ? void 0 : item.label) || (item === null || item === void 0 ? void 0 : item.value)),
      content: "".concat((_ref16 = (_item$count = item === null || item === void 0 ? void 0 : item.count) !== null && _item$count !== void 0 ? _item$count : item === null || item === void 0 ? void 0 : item.percentage) !== null && _ref16 !== void 0 ? _ref16 : 0, "%"),
      fieldKey: "commodityList[".concat(index, "]"),
      sectionTitle: ApplicationFormSectionTitleEnum.business
    });
  });
};
/**
 * Business: average radius of operation
 */


var buildAverageRadiusOperationData = function buildAverageRadiusOperationData(list, quoteDetails) {
  list.push(_objectSpread(_objectSpread({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.averageRadiusOfOperation),
    content: getAverageRadiusOperationDisplayText(quoteDetails),
    required: true,
    fieldKey: 'averageRadiusOfOperation',
    inputType: 'dropdown'
  }, getAverageRadiusOperationDropdownOptions()), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.business
  }));
};
/**
 * Business: number of losses
 */


var buildNumberOfLossesData = function buildNumberOfLossesData(list, quoteDetails) {
  var _ref17 = quoteDetails || {},
      numberLossesLast3Years = _ref17.numberLossesLast3Years,
      totalLossesPaidLast3Years = _ref17.totalLossesPaidLast3Years,
      noAnyCargoLoss = _ref17.noAnyCargoLoss;

  list.push({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.numberOfLosses),
    content: displayRawValue(numberLossesLast3Years),
    fieldKey: 'numberLossesLast3Years',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
  list.push({
    title: $t('kit:application_form.total_losses_paid_in_last_3_years'),
    content: "".concat(getCurrencySymbol(quoteDetails)).concat(totalLossesPaidLast3Years),
    fieldKey: 'totalLossesPaidLast3Years',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
  list.push({
    title: $t('kit:application_form.no_losses_paid'),
    content: displayRawValue(noAnyCargoLoss),
    fieldKey: 'noAnyCargoLoss',
    sectionTitle: ApplicationFormSectionTitleEnum.business
  });
};
/**
 * Business: years in business
 */


var buildYearsInBusinessData = function buildYearsInBusinessData(list, quoteDetails) {
  list.push(_objectSpread(_objectSpread({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.yearsInBusiness),
    content: getYearsInBusinessDisplayText(quoteDetails),
    required: true,
    fieldKey: 'yearsInBusiness',
    inputType: 'dropdown'
  }, getYearsInBusinessDropdownOptions()), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.business
  }));
};
/**
 * Vehicles: vehicle list (single row, separated by ';')
 */


var buildVehiclesData = function buildVehiclesData(list, quoteDetails) {
  var vehicleList = Array.isArray(quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.vehicleList) ? quoteDetails.vehicleList : [];
  var providerCode = quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.providerCode;

  var appendVehicleDisplayText = function appendVehicleDisplayText(vehicle) {
    if (!(vehicle !== null && vehicle !== void 0 && vehicle.make) && !(vehicle !== null && vehicle !== void 0 && vehicle.model)) {
      return '';
    }

    var yearOfManufacture = [PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode) ? '' : vehicle === null || vehicle === void 0 ? void 0 : vehicle.year_of_manufacture;
    var registrationNumber = vehicle !== null && vehicle !== void 0 && vehicle.registration_number ? " (".concat(vehicle === null || vehicle === void 0 ? void 0 : vehicle.registration_number, ")") : '';
    return "".concat((vehicle === null || vehicle === void 0 ? void 0 : vehicle.make) || '', " ").concat((vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) || '', " - ").concat(yearOfManufacture).concat(registrationNumber).replace(/\s+/g, ' ').trim();
  };

  var vehiclesText = (vehicleList.length ? vehicleList : [{}]).map(function (vehicle) {
    return appendVehicleDisplayText(vehicle);
  }).filter(Boolean).join('; ');
  list.push({
    title: $t('kit:quotes.vehicles'),
    content: vehiclesText,
    required: true,
    fieldKey: 'vehicleList',
    sectionTitle: ApplicationFormSectionTitleEnum.vehicles
  });
};
/**
 * Vehicles: number of drivers
 */


var buildNumberOfDriversData = function buildNumberOfDriversData(list, quoteDetails) {
  var _ref18 = quoteDetails || {},
      numberOfDrivers = _ref18.numberOfDrivers;

  list.push({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.numberOfDrivers),
    content: displayRawValue(numberOfDrivers),
    required: true,
    fieldKey: 'numberOfDrivers',
    sectionTitle: ApplicationFormSectionTitleEnum.vehicles
  });
};
/**
 * Vehicles: number of minor violations
 */


var buildMinorViolationsData = function buildMinorViolationsData(list, quoteDetails) {
  var _ref19 = quoteDetails || {},
      minorViolations = _ref19.minorViolations;

  list.push({
    title: getApplicationFormRowTitle(QuoteFormSectionTitleInfoEnum.minorViolations),
    content: displayRawValue(minorViolations),
    fieldKey: 'minorViolations',
    sectionTitle: ApplicationFormSectionTitleEnum.vehicles
  });
};
/**
 * Covers whose content is a Yes/No flag rather than a selectable amount.
 * Mirrors `isBooleanContentValueCoverage` in useQuotePriceDetailInfo.
 */


var isBooleanContentValueCoverage = function isBooleanContentValueCoverage(key) {
  return [PROPERTY_COVER_TYPE_LIST, PORTABLE_EQUIPMENT_COVER, BUSINESS_INTERUPTION, BI_COW_COVER, PORTABLE_EQUIPMENT].includes(key);
};
/**
 * Resolve one cover field into its display content.
 * - boolean covers (switches / property style) render Yes/No
 * - value covers render the selected option label resolved from coverOptions,
 *   falling back to the raw value when no option matches
 */


var getCoverFieldContent = function getCoverFieldContent(key, covers, coverOptions) {
  var _coverOptions$key, _matchedOption$label;

  var _getTruelyValueMap2 = getTruelyValueMap(),
      yes = _getTruelyValueMap2.yes,
      no = _getTruelyValueMap2.no;

  var rawValue = covers === null || covers === void 0 ? void 0 : covers[key];

  if (isBooleanContentValueCoverage(key) || typeof rawValue === 'boolean') {
    return rawValue ? yes.label : no.label;
  }

  if (!hasValue(rawValue)) {
    return '';
  }

  var matchedOption = coverOptions === null || coverOptions === void 0 ? void 0 : (_coverOptions$key = coverOptions[key]) === null || _coverOptions$key === void 0 ? void 0 : _coverOptions$key.find(function (item) {
    return item.value === rawValue;
  });
  return (_matchedOption$label = matchedOption === null || matchedOption === void 0 ? void 0 : matchedOption.label) !== null && _matchedOption$label !== void 0 ? _matchedOption$label : displayRawValue(rawValue);
};
/**
 * List every cover of the provider (fill-in amount or Yes/No), reusing the
 * canonical label map so the application form shows the complete cover set
 * rather than only the covers currently selected on the quote.
 *
 * When `config.asDropdown` is set, amount-style covers render as a PDF dropdown
 * sourced from the provider-specific cover options (quoteDetails.coverOptions[key]);
 * boolean (Yes/No) covers have no option list and stay free text.
 */


var appendCoverListData = function appendCoverListData(list, quoteDetails, coverKeyList, config) {
  var covers = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.covers) || {};
  var coverOptions = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.coverOptions) || {};
  var coverInfoMap = getCoverInfoMapWithExtraConfig({
    countryCode: quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.businessCountry,
    provideCode: quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.providerCode
  });
  var asDropdown = !!(config !== null && config !== void 0 && config.asDropdown);
  coverKeyList.forEach(function (key) {
    var _coverInfoMap$key;

    // In dropdown mode, resolve the content from the same complete provider option list that feeds
    // the dropdown (the quote's own coverOptions may be partial), so the selected label always
    // matches one of the options.
    var contentCoverOptions = asDropdown ? _objectSpread(_objectSpread({}, coverOptions), {}, _defineProperty({}, key, getCoverOptionList(quoteDetails, key))) : coverOptions;
    var row = {
      title: (coverInfoMap === null || coverInfoMap === void 0 ? void 0 : (_coverInfoMap$key = coverInfoMap[key]) === null || _coverInfoMap$key === void 0 ? void 0 : _coverInfoMap$key.label) || key,
      content: getCoverFieldContent(key, covers, contentCoverOptions),
      fieldKey: "covers.".concat(key),
      sectionTitle: ApplicationFormSectionTitleEnum.covers
    };

    if (asDropdown) {
      var _getCoverDropdownOpti = getCoverDropdownOptions(quoteDetails, key),
          options = _getCoverDropdownOpti.options,
          optionValues = _getCoverDropdownOpti.optionValues;

      if (options.length) {
        row.inputType = 'dropdown';
        row.options = options;
        row.optionValues = optionValues;
      }
    }

    list.push(row);
  });
};
/**
 * Covers: Accelerant GIT — coverage configuration + goods in transit covers.
 */


var buildGitCoversData = function buildGitCoversData(list, quoteDetails) {
  var coverageConfiguration = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.coverageConfiguration) || {};
  list.push(_objectSpread(_objectSpread({
    title: $t('kit:application_form.do_you_require_cover_in_the_eu'),
    content: coverageConfiguration.requireInEU ? $t('text:yes') : $t('text:no'),
    fieldKey: 'coverageConfiguration.requireInEU',
    inputType: 'dropdown'
  }, getYesNoDropdownOptions()), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.covers
  }));
  appendCoverListData(list, quoteDetails, [GOODS_IN_TRANSIT, CMR_COVER, PUBLIC_LIABILITY, EMPLOYERS_LIABILITY], {
    asDropdown: true
  });
};
/**
 * Covers: Accelerant — full professional/commercial cover set.
 */


var buildAccelerantCoversData = function buildAccelerantCoversData(list, quoteDetails) {
  appendCoverListData(list, quoteDetails, [PROFESSIONAL_INDEMNITY, EXCESS_LEVEL, FIDELITY_CRIME, PUBLIC_LIABILITY, EMPLOYERS_LIABILITY, DIRECTORS_OFFICERS_COVER, EMPLOYMENT_PRACTICES_COVER, EMPLOYMENT_PRACTICES_EXCESS_LEVEL, COMPUTER_BREAKDOWN_COVER, MONEY_ASSAULT_COVER // PROPERTY_COVER,
  // PORTABLE_EQUIPMENT_COVER,
  // BUSINESS_INTERUPTION,
  ], {
    asDropdown: true
  });
};
/**
 * Covers: Recruitment — Accelerant set plus drivers negligence.
 */


var buildRecruitmentCoversData = function buildRecruitmentCoversData(list, quoteDetails) {
  appendCoverListData(list, quoteDetails, [PROFESSIONAL_INDEMNITY, EXCESS_LEVEL, FIDELITY_CRIME, PUBLIC_LIABILITY, DRIVERS_NEGLIGENCE, EMPLOYERS_LIABILITY, DIRECTORS_OFFICERS_COVER, EMPLOYMENT_PRACTICES_COVER, EMPLOYMENT_PRACTICES_EXCESS_LEVEL, COMPUTER_BREAKDOWN_COVER, MONEY_ASSAULT_COVER // PROPERTY_COVER,
  // PROPERTY_COVER_TYPE_LIST,
  // PORTABLE_EQUIPMENT_COVER,
  // BUSINESS_INTERUPTION,
  ], {
    asDropdown: true
  });
};
/**
 * Covers: Great American (cargo) — mirrors generateGreatAmericanDisplaySelectCoverInfoList
 * but lists every cover so the applicant can complete the form.
 */


var buildGreatAmericanCoversData = function buildGreatAmericanCoversData(list, quoteDetails) {
  var covers = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.covers) || {};
  var coverOptions = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.coverOptions) || {};

  var _getTruelyValueMap3 = getTruelyValueMap(),
      yes = _getTruelyValueMap3.yes,
      no = _getTruelyValueMap3.no;

  var gaCoverMap = getGreateAmericanCoverMap();
  var coverMapInfoList = Object.values(gaCoverMap);

  var getCoverLabel = function getCoverLabel(value) {
    var _coverMapInfoList$fin;

    return (coverMapInfoList === null || coverMapInfoList === void 0 ? void 0 : (_coverMapInfoList$fin = coverMapInfoList.find(function (item) {
      return item.value === value;
    })) === null || _coverMapInfoList$fin === void 0 ? void 0 : _coverMapInfoList$fin.label) || value;
  };

  var pushCoverRow = function pushCoverRow(key, content) {
    list.push({
      title: getCoverLabel(key),
      content: content,
      fieldKey: "covers.".concat(key),
      sectionTitle: ApplicationFormSectionTitleEnum.covers
    });
  };

  [gaCoverMap.prePowerUnit.value, gaCoverMap.deductible.value, gaCoverMap.reloading.value, gaCoverMap.debrisRemoval.value, gaCoverMap.earnedFreight.value, gaCoverMap.fireDepartment.value, gaCoverMap.lossData.value, gaCoverMap.rewardCoverage.value, gaCoverMap.pollutantCleanUp.value].forEach(function (key) {
    var _coverOptions$key2, _matchedOption$label2;

    var selectValue = covers === null || covers === void 0 ? void 0 : covers[key];

    if (typeof selectValue === 'boolean') {
      selectValue = selectValue ? 1 : 0;
    }

    var matchedOption = hasValue(selectValue) ? coverOptions === null || coverOptions === void 0 ? void 0 : (_coverOptions$key2 = coverOptions[key]) === null || _coverOptions$key2 === void 0 ? void 0 : _coverOptions$key2.find(function (item) {
      return item.value === selectValue;
    }) : undefined;
    pushCoverRow(key, (_matchedOption$label2 = matchedOption === null || matchedOption === void 0 ? void 0 : matchedOption.label) !== null && _matchedOption$label2 !== void 0 ? _matchedOption$label2 : hasValue(selectValue) ? displayRawValue(selectValue) : '');
  });
  [gaCoverMap.refrigerationBreakdown.value, gaCoverMap.ownersGoodsExtension.value].forEach(function (key) {
    pushCoverRow(key, covers !== null && covers !== void 0 && covers[key] ? yes.label : no.label);
  });
  [{
    existKey: gaCoverMap.nonOwnedTrailer.value,
    limitKey: gaCoverMap.nonOwnedTrailerLimit.value
  }, {
    existKey: gaCoverMap.reusablePackingContainers.value,
    limitKey: gaCoverMap.reusablePackingContainersLimit.value
  }, {
    existKey: gaCoverMap.tarpsChains.value,
    limitKey: gaCoverMap.tarpsChainsLimit.value
  }].forEach(function (_ref20) {
    var _coverOptions$limitKe, _matchedOption$label3;

    var existKey = _ref20.existKey,
        limitKey = _ref20.limitKey;
    pushCoverRow(existKey, covers !== null && covers !== void 0 && covers[existKey] ? yes.label : no.label);
    var limitValue = covers === null || covers === void 0 ? void 0 : covers[limitKey];
    var matchedOption = hasValue(limitValue) ? coverOptions === null || coverOptions === void 0 ? void 0 : (_coverOptions$limitKe = coverOptions[limitKey]) === null || _coverOptions$limitKe === void 0 ? void 0 : _coverOptions$limitKe.find(function (item) {
      return item.value === limitValue;
    }) : undefined;
    pushCoverRow(limitKey, (_matchedOption$label3 = matchedOption === null || matchedOption === void 0 ? void 0 : matchedOption.label) !== null && _matchedOption$label3 !== void 0 ? _matchedOption$label3 : hasValue(limitValue) ? displayRawValue(limitValue) : '');
  });
};
/**
 * Covers: cover type
 */


var buildCoverTypeData = function buildCoverTypeData(list, quoteDetails) {
  list.push({
    title: $t('kit:quotes.cover_type'),
    content: getCoverTypeDisplayText(quoteDetails),
    required: true,
    fieldKey: 'coverType',
    sectionTitle: ApplicationFormSectionTitleEnum.covers
  });
};
/**
 * Covers: custom input coverages
 */


var buildCustomInputCoveragesData = function buildCustomInputCoveragesData(list, quoteDetails) {
  var customizedCovers = Array.isArray(quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.customizedCovers) ? quoteDetails.customizedCovers : [];
  var currencySymbol = getCurrencySymbol(quoteDetails);
  customizedCovers.forEach(function (item, index) {
    if (!hasValue(item === null || item === void 0 ? void 0 : item.name) && !hasValue(item === null || item === void 0 ? void 0 : item.coverage)) {
      return;
    }

    list.push({
      title: "".concat($t('kit:application_form.custom_cover'), " ").concat(index + 1, " - ").concat((item === null || item === void 0 ? void 0 : item.name) || $t('kit:application_form.name')),
      content: hasValue(item === null || item === void 0 ? void 0 : item.coverage) ? "".concat(currencySymbol).concat(item.coverage) : '',
      fieldKey: "customizedCovers[".concat(index, "].coverage"),
      sectionTitle: ApplicationFormSectionTitleEnum.covers
    });
  });
};
/**
 * Covers: property related covers (portable equipment / business interruption)
 */


var buildPropertyCoversData = function buildPropertyCoversData(list, quoteDetails) {// const { portableEquipmentInsured, businessInterruptionInsured } = quoteDetails || {};
  // list.push({
  //   title: 'Portable equipment insured',
  //   content: `${getCurrencySymbol(quoteDetails)}${portableEquipmentInsured || 0}`,
  //   fieldKey: 'portableEquipmentInsured',
  //   sectionTitle: ApplicationFormSectionTitleEnum.covers,
  // });
  // list.push({
  //   title: 'Business interruption insured',
  //   content: `${getCurrencySymbol(quoteDetails)}${businessInterruptionInsured || 0}`,
  //   fieldKey: 'businessInterruptionInsured',
  //   sectionTitle: ApplicationFormSectionTitleEnum.covers,
  // });
};
/**
 * Claims: has claims + claim list (single row; fields of one claim separated
 * by ',', claims separated by ';')
 */


var buildClaimsData = function buildClaimsData(list, quoteDetails) {
  var _ref21 = quoteDetails || {},
      hasClaims = _ref21.hasClaims,
      claimList = _ref21.claimList;

  list.push(_objectSpread(_objectSpread({
    title: $t('kit:application_form.do_you_have_any_claims'),
    content: displayRawValue(hasClaims),
    required: true,
    fieldKey: 'hasClaims',
    inputType: 'dropdown'
  }, getYesNoDropdownOptions()), {}, {
    sectionTitle: ApplicationFormSectionTitleEnum.claims
  }));
  var currencySymbol = getCurrencySymbol(quoteDetails);
  var claimsText = (Array.isArray(claimList) ? claimList : []).filter(function (item) {
    return hasValue(item === null || item === void 0 ? void 0 : item.amount) || hasValue(item === null || item === void 0 ? void 0 : item.date) || hasValue(item === null || item === void 0 ? void 0 : item.additionalInfo);
  }).map(function (item) {
    return [hasValue(item === null || item === void 0 ? void 0 : item.amount) ? "".concat(currencySymbol).concat(item.amount) : '', displayDateValue(item === null || item === void 0 ? void 0 : item.date), displayRawValue(item === null || item === void 0 ? void 0 : item.additionalInfo)].filter(Boolean).join(', ');
  }).filter(Boolean).join('; ');
  list.push({
    title: $t('kitQuestion:claims'),
    content: claimsText,
    fieldKey: 'claimList',
    sectionTitle: ApplicationFormSectionTitleEnum.claims
  });
};

var flattenQuestionSpecText = function flattenQuestionSpecText(list) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var lines = [];
  (list || []).forEach(function (item) {
    if (item !== null && item !== void 0 && item.text) {
      lines.push("".concat('  '.repeat(depth)).concat(item.text));
    }

    if (Array.isArray(item === null || item === void 0 ? void 0 : item.list) && item.list.length > 0) {
      lines.push.apply(lines, _toConsumableArray(flattenQuestionSpecText(item.list, depth + 1)));
    }
  });
  return lines;
};

var getDeclarationFullText = function getDeclarationFullText(questionInfo) {
  var _ref22 = questionInfo || {},
      title = _ref22.title,
      subTitle = _ref22.subTitle,
      spec = _ref22.spec;

  return [title, subTitle].concat(_toConsumableArray(flattenQuestionSpecText(spec))).filter(Boolean).join('\n');
};

var DECLARATION_TITLE_LINE_STYLE = {
  fontSize: 10,
  bold: true,
  color: '#1F245C',
  kind: 'title'
};
var DECLARATION_SUBTITLE_LINE_STYLE = {
  fontSize: 10,
  bold: true,
  color: '#333C66',
  kind: 'subTitle'
};
var DECLARATION_DESCTITLE_LINE_STYLE = {
  fontSize: 9,
  color: '#55608F',
  kind: 'descTitle'
}; // Spec items with their own nested list are group headings (e.g. "Claims",
// "Convictions, CCJs and Disqualifications") and are drawn bold and slightly
// larger than the bullet items below them.

var DECLARATION_SPEC_TITLE_LINE_STYLE = {
  fontSize: 10,
  bold: true,
  color: '#333C66',
  kind: 'spec'
};
var DECLARATION_SPEC_LINE_STYLE = {
  fontSize: 9,
  color: '#444B6E',
  kind: 'spec'
};
var DECLARATION_SPEC_ITEM_GAP = 10;
/**
 * Normalize a declaration field into a rich text line.
 *
 * The value can be a plain string or a structured item (e.g. an array of
 * objects) where each item may carry its own text / fontSize / bold / color.
 */

var normalizeTextLine = function normalizeTextLine(value, style) {
  if (!hasValue(value)) {
    return null;
  }

  if (typeof value === 'string') {
    return _objectSpread({
      text: value
    }, style);
  }

  if (typeof value === 'object') {
    var _ref23, _value$text, _value$fontSize, _value$bold, _value$color, _value$indent, _value$bullet;

    var text = (_ref23 = (_value$text = value === null || value === void 0 ? void 0 : value.text) !== null && _value$text !== void 0 ? _value$text : value === null || value === void 0 ? void 0 : value.label) !== null && _ref23 !== void 0 ? _ref23 : '';

    if (!hasValue(text)) {
      return null;
    }

    return {
      text: text,
      fontSize: (_value$fontSize = value === null || value === void 0 ? void 0 : value.fontSize) !== null && _value$fontSize !== void 0 ? _value$fontSize : style.fontSize,
      bold: (_value$bold = value === null || value === void 0 ? void 0 : value.bold) !== null && _value$bold !== void 0 ? _value$bold : style.bold,
      color: (_value$color = value === null || value === void 0 ? void 0 : value.color) !== null && _value$color !== void 0 ? _value$color : style.color,
      indent: (_value$indent = value === null || value === void 0 ? void 0 : value.indent) !== null && _value$indent !== void 0 ? _value$indent : style.indent,
      bullet: (_value$bullet = value === null || value === void 0 ? void 0 : value.bullet) !== null && _value$bullet !== void 0 ? _value$bullet : style.bullet,
      kind: style.kind
    };
  }

  return _objectSpread({
    text: String(value)
  }, style);
};

var appendTextLines = function appendTextLines(lines, value, style) {
  if (Array.isArray(value)) {
    value.forEach(function (item) {
      var line = normalizeTextLine(item, style);

      if (line) {
        lines.push(line);
      }
    });
    return;
  }

  var line = normalizeTextLine(value, style);

  if (line) {
    lines.push(line);
  }
};

var appendSpecLines = function appendSpecLines(lines, list) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var isFirstSpecLine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  (list || []).forEach(function (item) {
    var hasChildren = Array.isArray(item === null || item === void 0 ? void 0 : item.list) && item.list.length > 0;

    if (item !== null && item !== void 0 && item.text) {
      // Only separate top-level spec groups; keep a group heading and its
      // nested items tightly together.
      var gap = depth === 0 && !isFirstSpecLine ? {
        gapBefore: DECLARATION_SPEC_ITEM_GAP
      } : {};
      lines.push(hasChildren ? _objectSpread(_objectSpread({
        text: item.text
      }, DECLARATION_SPEC_TITLE_LINE_STYLE), {}, {
        indent: depth
      }, gap) : _objectSpread(_objectSpread({
        text: item.text
      }, DECLARATION_SPEC_LINE_STYLE), {}, {
        indent: depth,
        bullet: item.hideDot ? '' : "\u2022"
      }, gap));
      isFirstSpecLine = false;
    }

    if (hasChildren) {
      appendSpecLines(lines, item.list, depth + 1, isFirstSpecLine);
    }
  });
};
/**
 * Build the declaration label lines so each field (title / subTitle /
 * descTitle / spec) is rendered on its own line with its own style.
 */


var getDeclarationTitleLines = function getDeclarationTitleLines(questionInfo) {
  var _ref24 = questionInfo || {},
      title = _ref24.title,
      subTitle = _ref24.subTitle,
      descTitle = _ref24.descTitle,
      spec = _ref24.spec;

  var lines = [];
  appendTextLines(lines, title, DECLARATION_TITLE_LINE_STYLE);
  appendTextLines(lines, subTitle, DECLARATION_SUBTITLE_LINE_STYLE);
  appendTextLines(lines, descTitle, DECLARATION_DESCTITLE_LINE_STYLE);
  appendSpecLines(lines, spec);
  return lines;
};

var pushDeclarationQuestionRow = function pushDeclarationQuestionRow(list, quoteDetails, questionId) {
  var _getAllQuoteQuestionI;

  var sectionTitle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ApplicationFormSectionTitleEnum.declarations;
  var questionInfoOverride = arguments.length > 4 ? arguments[4] : undefined;
  var config = arguments.length > 5 ? arguments[5] : undefined;
  var declarationQuestions = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.declarationQuestions) || {};
  var answer = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : declarationQuestions[questionId];
  var questionInfo = questionInfoOverride !== null && questionInfoOverride !== void 0 ? questionInfoOverride : (_getAllQuoteQuestionI = getAllQuoteQuestionInfoMap()) === null || _getAllQuoteQuestionI === void 0 ? void 0 : _getAllQuoteQuestionI[questionId];

  if (config !== null && config !== void 0 && config.customTitle && questionInfo) {
    questionInfo.title = config.customTitle;
  }

  var titleLines = getDeclarationTitleLines(questionInfo); // The label pair depends on the question's confirmType ('1' I agree/I disagree, '2' Yes/No,
  // '3' Include/Exclude); all transmit the answer's truelyValue. Resolve the row content from the
  // same option set so the selected value always matches one of the dropdown labels.

  var _getDeclarationDropdo = getDeclarationDropdownOptions(questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.confirmType),
      options = _getDeclarationDropdo.options,
      optionValues = _getDeclarationDropdo.optionValues;

  var answerIndex = answer ? optionValues.indexOf(answer.truelyValue ? 'true' : 'false') : -1;
  var content = answerIndex >= 0 ? options[answerIndex] : '';
  list.push({
    title: getDeclarationFullText(questionInfo) || questionId,
    titleLines: titleLines.length > 0 ? titleLines : undefined,
    content: content,
    required: true,
    fieldKey: "declarationQuestions.".concat(questionId),
    inputType: 'dropdown',
    options: options,
    optionValues: optionValues,
    sectionTitle: sectionTitle
  });
};
/**
 * Append the free-text declaration comment row when the applicant disagreed
 * with one of the given declarations (or a comment already exists).
 */


var appendDeclarationCommentRow = function appendDeclarationCommentRow(list, quoteDetails, questionIdList) {
  var declarationQuestions = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.declarationQuestions) || {};
  var hasDisagreed = questionIdList.some(function (id) {
    var _declarationQuestions;

    return (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions = declarationQuestions[id]) === null || _declarationQuestions === void 0 ? void 0 : _declarationQuestions.truelyValue) === false;
  });

  if (hasDisagreed || quoteDetails !== null && quoteDetails !== void 0 && quoteDetails.declarationComment) {
    list.push({
      title: $t('kit:application_form.declaration_comment'),
      content: quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.declarationComment,
      fieldKey: 'declarationComment',
      sectionTitle: ApplicationFormSectionTitleEnum.declarations
    });
  }
};
/**
 * Declarations: static declaration questions + comment (GIT / Great American).
 */


var buildDeclarationsData = function buildDeclarationsData(list, quoteDetails, config) {
  var _config$questionIdLis;

  var declarationQuestions = (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.declarationQuestions) || {};
  var questionIdList = config !== null && config !== void 0 && (_config$questionIdLis = config.questionIdList) !== null && _config$questionIdLis !== void 0 && _config$questionIdLis.length ? config.questionIdList : Object.keys(declarationQuestions || {});
  questionIdList.forEach(function (questionId) {
    pushDeclarationQuestionRow(list, quoteDetails, questionId);
  });
  appendDeclarationCommentRow(list, quoteDetails, questionIdList);
};
/**
 * Declarations: Accelerant.
 *
 * The declaration question id is dynamic (fetched by quote id in the hook), so
 * the question text is resolved here: accountancy questions drop the
 * non-applicable accountancy activities, and a generic declaration is appended
 * unless the quote is an estate-agent / accountancy / combined R2R scheme.
 */


var buildAccelerantDeclarationsData = function buildAccelerantDeclarationsData(list, quoteDetails) {
  var businessActivity = quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.businessActivity;
  var isCombineR2RScheme = judgeQuoteIsCombineR2RScheme({
    dataHandleSourceKey: 'promotionPayload',
    promotionInfo: quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.promotionInfo
  });
  var isAccountancyActivities = judgeCanChooseAccountancyActivities(businessActivity);
  var isEstateAgentActivities = judgeCanChooseEstateAgentActivities(businessActivity);

  if (isCombineR2RScheme) {
    pushDeclarationQuestionRow(list, quoteDetails, 'integrated_insurance_desk_scheme_acceptance');
  }

  var dynamicQuestionId = quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.dynamicDeclarationQuestionId;

  if (dynamicQuestionId) {
    var _getAllQuoteQuestionI2;

    var questionInfo = (_getAllQuoteQuestionI2 = getAllQuoteQuestionInfoMap()) === null || _getAllQuoteQuestionI2 === void 0 ? void 0 : _getAllQuoteQuestionI2[dynamicQuestionId];

    if (dynamicQuestionId.includes('accountants')) {
      questionInfo = removeAccountancyDeclarations(questionInfo, {
        accountancyActivies: (quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.accountancyActivityList) || []
      });
    }

    pushDeclarationQuestionRow(list, quoteDetails, dynamicQuestionId, ApplicationFormSectionTitleEnum.declarations, questionInfo);
  }

  if (!(isEstateAgentActivities || isAccountancyActivities || isCombineR2RScheme)) {
    pushDeclarationQuestionRow(list, quoteDetails, 'accelerant_generic_declaration');
  }

  appendDeclarationCommentRow(list, quoteDetails, dynamicQuestionId ? [dynamicQuestionId] : []);
};
/**
 * Declarations: Recruitment.
 *
 * The recruitment declaration text is generated dynamically from the selected
 * covers (D&O / employers practices liability); it is computed in the hook via
 * useRecruitmentDeclaration and passed through as recruitmentDeclarationQuestionInfo.
 */


var buildRecruitmentDeclarationsData = function buildRecruitmentDeclarationsData(list, quoteDetails) {
  pushDeclarationQuestionRow(list, quoteDetails, RECRUITMENT_DECLARATION, ApplicationFormSectionTitleEnum.declarations, quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.recruitmentDeclarationQuestionInfo);
  appendDeclarationCommentRow(list, quoteDetails, [RECRUITMENT_DECLARATION]);
};
/**
 * Declarations: Great American — the question set depends on whether the quote
 * is on the fast-track flow.
 */


var buildGreatAmericanDeclarationsData = function buildGreatAmericanDeclarationsData(list, quoteDetails) {
  var _quoteDetails$declara, _quoteDetails$declara2;

  var isFastTrack = (quoteDetails === null || quoteDetails === void 0 ? void 0 : (_quoteDetails$declara = quoteDetails.declarationQuestions) === null || _quoteDetails$declara === void 0 ? void 0 : (_quoteDetails$declara2 = _quoteDetails$declara.great_american_fast_process_criteria) === null || _quoteDetails$declara2 === void 0 ? void 0 : _quoteDetails$declara2.truelyValue) === true;
  var questionIdList = isFastTrack ? ['user_confirm_received', GREAT_AMERICAN_FAST_PROCESS_DECLARATION_P1] : ['greate_american_acceptance_criteria', GREAT_AMERICAN_DECLARATION_P1, 'user_confirm_received'];
  buildDeclarationsData(list, quoteDetails, {
    questionIdList: questionIdList
  });
};

var GREAT_AMERICAN_BUSINESS_QUESTION_ID_LIST = ['greate_american_use_what_car', 'greate_american_mixed_courier_work', 'greate_american_cargo_loses'];
var GREAT_AMERICAN_DRIVERS_QUESTION_ID_LIST = ['greate_american_drivers_age_range', 'greate_american_drivers_age_range_acceptable_dot'];
var RECRUITMENT_QUESTION_ID_LIST = ['recruitment_not_contractually_responsible', 'placements_within_white_collar'];
/**
 * Accelerant GIT quote: build the flat application form rows.
 */

var generateGitApplicationFormSectionsData = function generateGitApplicationFormSectionsData(quoteDetails) {
  var list = [];
  buildContactInformationData(list, quoteDetails);
  buildBusinessTypeData(list, quoteDetails);
  buildPersonalData(list, quoteDetails);
  buildCompanyAndAddressData(list, quoteDetails);
  buildPolicyStartDateData(list, quoteDetails);
  buildBusinessActivityData(list, quoteDetails);
  buildInsuranceBundleData(list, quoteDetails);
  buildNumberOfEmployeesData(list, quoteDetails);
  buildVehiclesData(list, quoteDetails);
  buildGitCoversData(list, quoteDetails);
  buildDeclarationsData(list, quoteDetails, {
    questionIdList: [GIT_DECLARATION_ID]
  });
  return list;
};
/**
 * Accelerant quote: build the flat application form rows.
 */


var generateAccelerantApplicationFormSectionsData = function generateAccelerantApplicationFormSectionsData(quoteDetails) {
  var list = [];
  buildContactInformationData(list, quoteDetails);
  buildBusinessTypeData(list, quoteDetails);
  buildCompanyAndAddressData(list, quoteDetails); // buildTypeOfPolicyData(list, quoteDetails);

  buildRetroactiveDateData(list, quoteDetails);
  buildPolicyStartDateData(list, quoteDetails);
  buildBusinessActivityData(list, quoteDetails);
  buildEstimatedTurnoverData(list, quoteDetails);
  buildIncomeSplitData(list, quoteDetails);
  buildCompositionEmployeesData(list, quoteDetails); // buildCoverTypeData(list, quoteDetails);

  buildAccelerantCoversData(list, quoteDetails);
  buildCustomInputCoveragesData(list, quoteDetails);
  buildPropertyCoversData(list, quoteDetails);
  buildClaimsData(list, quoteDetails);
  buildAccelerantDeclarationsData(list, quoteDetails);
  return list;
};
/**
 * Recruitment quote: build the flat application form rows.
 */


var generateRecruitmentApplicationFormSectionsData = function generateRecruitmentApplicationFormSectionsData(quoteDetails) {
  var list = [];
  buildContactInformationData(list, quoteDetails);
  buildBusinessTypeData(list, quoteDetails);
  buildCompanyAndAddressData(list, quoteDetails);
  buildRetroactiveDateData(list, quoteDetails);
  buildPolicyStartDateData(list, quoteDetails);
  buildBusinessActivityData(list, quoteDetails);
  buildRecruitmentBusinessTypeData(list, quoteDetails);
  buildEstimatedTurnoverData(list, quoteDetails);
  buildRecruitmentEstimatedSplitData(list, quoteDetails);
  buildIncomeSplitData(list, quoteDetails);
  buildNumberOfEmployeesData(list, quoteDetails);
  buildPayrollForPlacedCandidatesData(list, quoteDetails);
  buildPlacedCandidateSplitData(list, quoteDetails);
  buildPlacementIndustriesPercentageData(list, quoteDetails);
  buildEmployerReferenceNumberData(list, quoteDetails);
  RECRUITMENT_QUESTION_ID_LIST.forEach(function (questionId) {
    return pushDeclarationQuestionRow(list, quoteDetails, questionId, ApplicationFormSectionTitleEnum.business);
  }); // buildCoverTypeData(list, quoteDetails);

  buildRecruitmentCoversData(list, quoteDetails);
  buildCustomInputCoveragesData(list, quoteDetails);
  buildPropertyCoversData(list, quoteDetails);
  buildClaimsData(list, quoteDetails);
  buildRecruitmentDeclarationsData(list, quoteDetails);
  return list;
};
/**
 * Great American quote: build the flat application form rows.
 */


var generateGreateAmericanApplicationFormSectionsData = function generateGreateAmericanApplicationFormSectionsData(quoteDetails) {
  var list = [];
  buildContactInformationData(list, quoteDetails);
  pushDeclarationQuestionRow(list, quoteDetails, 'great_american_fast_process_criteria', ApplicationFormSectionTitleEnum.client, null, {
    customTitle: $t('kit:application_form.fast_process_criteria')
  });
  buildBusinessTypeData(list, quoteDetails);
  buildGreatAmericanCompanyAndAddressData(list, quoteDetails);
  buildPolicyStartDateData(list, quoteDetails);
  buildDotNumberData(list, quoteDetails);
  buildTypeOfRemovalJobData(list, quoteDetails);
  GREAT_AMERICAN_BUSINESS_QUESTION_ID_LIST.forEach(function (questionId) {
    return pushDeclarationQuestionRow(list, quoteDetails, questionId, ApplicationFormSectionTitleEnum.business);
  });
  buildTypeOfCommoditiesData(list, quoteDetails);
  buildAverageRadiusOperationData(list, quoteDetails);
  buildNumberOfLossesData(list, quoteDetails);
  buildYearsInBusinessData(list, quoteDetails);
  buildNumberOfDriversData(list, quoteDetails);
  GREAT_AMERICAN_DRIVERS_QUESTION_ID_LIST.forEach(function (questionId) {
    return pushDeclarationQuestionRow(list, quoteDetails, questionId, ApplicationFormSectionTitleEnum.vehicles);
  });
  buildMinorViolationsData(list, quoteDetails);
  buildVehiclesData(list, quoteDetails);
  buildGreatAmericanCoversData(list, quoteDetails);
  buildGreatAmericanDeclarationsData(list, quoteDetails);
  return list;
};
/**
 * Broker details: promotion / broker information reused from the quote and
 * policy detail views, prepended uniformly for every provider.
 *
 * The shared helper already resolves the partner / broker / direct-sale cases,
 * so each returned entry is mapped to a plain title + content form row (the
 * link / className metadata it carries is not part of the application form row).
 * Every editable row needs a string fieldKey for the PDF text field, so an
 * index-based key is assigned here.
 */


var buildBrokerDetailsData = function buildBrokerDetailsData(list, quoteDetails) {
  var _ref25 = quoteDetails || {},
      promotionInfo = _ref25.promotionInfo,
      firstName = _ref25.firstName,
      lastName = _ref25.lastName,
      source = _ref25.source;

  var informationList = getQuoteRelatedUserAndPromotionInformationList(promotionInfo, {
    source: source,
    fullName: "".concat(firstName || '', " ").concat(lastName || '').trim()
  });
  informationList.forEach(function (item, index) {
    var row = {
      title: (item === null || item === void 0 ? void 0 : item.title) || '',
      content: item === null || item === void 0 ? void 0 : item.content,
      fieldKey: "brokerDetails[".concat(index, "]")
    };
    list.push(_objectSpread(_objectSpread({}, row), {}, {
      sectionTitle: ApplicationFormSectionTitleEnum.broker
    }));
  });
};
/**
 * Group the flat rows by sectionTitle and convert them into the
 * { sectionTitle, rows } shape consumed by the application form renderer.
 */


var groupApplicationFormSectionsData = function groupApplicationFormSectionsData(list) {
  var sectionTitleMap = getApplicationFormSectionTitleMap();
  return Object.keys(sectionTitleMap).map(function (sectionTitle) {
    return {
      sectionTitle: sectionTitleMap[sectionTitle],
      sectionKey: sectionTitle,
      rows: list.filter(function (item) {
        return item.sectionTitle === sectionTitle;
      }).map(function (_ref26) {
        var _sectionTitle = _ref26.sectionTitle,
            row = _objectWithoutProperties(_ref26, _excluded);

        return row;
      })
    };
  }).filter(function (section) {
    return section.rows.length > 0;
  }).map(function (section, index) {
    return _objectSpread(_objectSpread({}, section), {}, {
      sectionTitle: "".concat(index + 1, ". ").concat(section.sectionTitle)
    });
  });
};
/**
 * Additional information: a shared free-text section appended for every
 * provider. It lets the user type arbitrary corrections or extra details that
 * are not covered by the structured rows. The single row is a standard
 * editable value cell with a temporary six-line minimum height.
 */


var buildAdditionalInformationData = function buildAdditionalInformationData(list) {
  list.push({
    title: $t('kit:application_form.please_add_any_corrections_or_extra_information_here'),
    content: '',
    fieldKey: 'additionalInformation',
    minLines: 6,
    sectionTitle: ApplicationFormSectionTitleEnum.additionalInformation
  });
};
/**
 * Build the application form sections for a quote.
 *
 * The entry dispatches by providerCode so different PROVIDER_SOURCE values can
 * reuse the same modular builders (contact info, business type, ...).
 */


export var generateApplicationFormSectionsData = function generateApplicationFormSectionsData(quoteDetails) {
  var list = [];

  if (quoteDetails !== null && quoteDetails !== void 0 && quoteDetails.promotionId) {
    buildBrokerDetailsData(list, quoteDetails);
  }

  if ([PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.providerCode)) {
    list.push.apply(list, _toConsumableArray(generateGitApplicationFormSectionsData(quoteDetails)));
  } else if ([PROVIDER_SOURCE().ACCELERANT.value].includes(quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.providerCode)) {
    list.push.apply(list, _toConsumableArray(generateAccelerantApplicationFormSectionsData(quoteDetails)));
  } else if ([PROVIDER_SOURCE().RECRUITMENT.value].includes(quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.providerCode)) {
    list.push.apply(list, _toConsumableArray(generateRecruitmentApplicationFormSectionsData(quoteDetails)));
  } else if ([PROVIDER_SOURCE().GREATEAMERICAN.value].includes(quoteDetails === null || quoteDetails === void 0 ? void 0 : quoteDetails.providerCode)) {
    list.push.apply(list, _toConsumableArray(generateGreateAmericanApplicationFormSectionsData(quoteDetails)));
  }

  buildAdditionalInformationData(list);
  return groupApplicationFormSectionsData(list);
};